import { Link } from '@openx/components-core/lib/Link/Link.tsx';
import { useFormContext } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';

import type { Group } from '../../utils/context/DealHookTypes.ts';

type LinkWithStateProps = Pick<Group[number], 'name' | 'uid'> & { isOutside: boolean };

export const LinkWithState = ({ isOutside, name, uid }: LinkWithStateProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getValues } = useFormContext();
  const formValues = getValues();

  const onClick = () => {
    if (!isOutside) return;

    navigate({}, { state: { deal: formValues, redirectPath: location.pathname } });
  };

  return (
    <Link
      to={`/deals/${uid}/details`}
      isDisabled={!isOutside}
      onClick={onClick}
      data-test={`grouped-item-deal-${name}-link`}
      state={{ deal: formValues, redirectPath: location.pathname }}
    >
      {name}
    </Link>
  );
};
